import Avatar from "./Avatar";
import { autorDe } from "../../services/quien";
import { diaAr } from "../../shared/fechaAr";

/* Quién cargó esta fila, en un chip.
 *
 * ES EL MISMO EN TODAS LAS PANTALLAS. Antes vivía metido adentro de Viajes,
 * con el nombre y la foto resueltos ahí mismo (`creadorNombreCompleto`,
 * `creadorFotoUrl`). Eso significaba que cualquier otra pantalla que quisiera
 * mostrar el autor tenía que copiar esa lógica — y el día que las dos copias
 * difieran, el hub va a decir dos cosas distintas sobre la misma persona.
 *
 * EL NOMBRE SALE DE LA FILA, no del padrón. `usuario_nombre` se congela cuando
 * se guarda, así que una carga vieja sigue diciendo quién la hizo aunque esa
 * persona se haya ido. Lo único que se busca afuera es la FOTO — y si no está,
 * las iniciales alcanzan.
 *
 * SIN AUTOR SE DIBUJA UN GUION Y NO UN CHIP VACÍO. Las filas anteriores a esto
 * no tienen quién, y un círculo con iniciales en blanco se leería como una
 * persona sin nombre en vez de como un dato que no existe.
 */
const ChipUsuario = ({ fila, porMail = null, autor: yaResuelto = null,
                      size = 26 }) => {
  const autor = yaResuelto ?? autorDe(fila, porMail);
  if (!autor) return <span className="tenue">—</span>;

  // El hover dice el nombre y el mail. El mail va porque hay nombres que se
  // repiten y porque es lo que sirve para escribirle a esa persona.
  //
  // LA FECHA SE BUSCA EN VARIAS COLUMNAS porque cada tabla la llama distinto:
  // el padrón heredó `ultimaModificacion` de Firestore y `chofer_documentos`
  // —que nació acá— usa `actualizado_en`. Sin la segunda, el hover de
  // documentación decía quién y no cuándo, que es la mitad de la respuesta:
  // «lo cargó Ana» no sirve para nada si no se sabe si fue ayer o en marzo.
  const cuando =
    fila?.ultimaModificacion ||
    fila?.actualizado_en ||
    fila?.creado ||
    fila?.fecha ||
    "";
  if (autor.sistema) {
    // Sin avatar: un círculo con iniciales se lee como una persona, y esto es
    // un sistema. Va como pastilla, que es lo que ya usamos para las etiquetas.
    return (
      <span className="chip-sistema" title="Cargado en CantApp, el sistema original, antes de que el hub guardara quién">
        {autor.nombre}
      </span>
    );
  }

  const titulo = [
    autor.nombre,
    autor.nombre !== autor.mail ? autor.mail : "",
    cuando ? `cargado ${diaAr(cuando)}` : "",
  ]
    .filter(Boolean)
    .join(" · ");

  return (
    <Avatar
      nombreCompleto={autor.nombre}
      fotoUrl={autor.fotoUrl}
      size={size}
      title={titulo}
    />
  );
};

export default ChipUsuario;
